import { render, staticRenderFns } from "./ChatBotButton.vue?vue&type=template&id=ed2b5e90&scoped=true"
import script from "./ChatBotButton.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatBotButton.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ChatBotButton.vue?vue&type=style&index=0&id=ed2b5e90&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed2b5e90",
  null
  
)

export default component.exports